import React, { Fragment } from 'react';
export function PainPointsSection() {
  const painPoints = ['"Stolen" Sunday evenings searching for drills that actually work for a team.', 'Fragmented sessions without a unified curriculum for the full season.', 'On-ice panic when group size changes and you have no rotation plan ready.', 'Creative fatigue from trying to "reinvent the wheel" every single week.'];
  return <section className="bg-brand-dark py-16 md:py-24 px-4 border-t border-brand-border" data-id="element-167">
      <div className="max-w-3xl mx-auto" data-id="element-168">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-white text-center mb-10 md:mb-14 leading-snug px-2" data-id="element-169">
          If you coach ICE Hockey,
          <br data-id="element-170" />
          <span className="text-brand-accent" data-id="element-171">you know this feeling:</span>
        </h2>
        <div className="space-y-4 md:space-y-5 mb-14 md:mb-16" data-id="element-172">
          {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 md:gap-5 py-5 md:py-6 px-5 md:px-7 rounded-2xl bg-[#1B1013] border border-[#3A1F24]" data-id="element-173">
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 bg-brand-red/20 rounded-lg flex items-center justify-center text-brand-red font-black text-lg md:text-xl" data-id="element-174">
                ✕
              </div>
              <p className="text-base sm:text-lg md:text-xl text-white/90 font-semibold leading-snug" data-id="element-175">
                {point}
              </p>
            </div>)}
        </div>
        <div className="text-center px-4" data-id="element-176">
          <p className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold leading-tight italic text-[#FF4D33]" data-id="element-177">
            How many hours have you already lost starting from scratch?
          </p>
        </div>
      </div>
    </section>;
}